"use strict";

var _regeneratorRuntime = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _get = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _classCallCheck = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable new-cap */

var querystring_1 = __importDefault(require("querystring"));

var util_1 = __importDefault(require("util"));

var axios_1 = __importDefault(require("axios"));

var uuid_1 = __importDefault(require("uuid"));

var site_1 = require("../config/site");

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/';
var sessionJwt = typeof localStorage === 'undefined' ? undefined : localStorage.getItem('sessionJwt'); // El pre-session-token es un mecanismo para evitar duplicidad en los primeros
// request realizados desde la carga de la pagina incial de REACT y antes que BFF
// asigne el token JWT

var preSessionToken = uuid_1.default.v4();

var persistJwt = function persistJwt(response) {
  if (response) {
    sessionJwt = response.headers['x-session-jwt'];

    if (sessionJwt) {
      localStorage.setItem('sessionJwt', sessionJwt);
    }
  }
};

axios_1.default.interceptors.request.use(function (config) {
  // Set 4 characters SITE_ID
  config.headers['x-site-id'] = site_1.siteId; // eslint-disable-line no-param-reassign
  // Set sessionJwt to each request

  if (!sessionJwt) {
    // Si no tiene token JWT debe enviar el pre-session-token para que BFF pueda asignarle
    // a esta "session" el mismo token JWT cuando lo genere nuevo
    config.headers['x-pre-session-token'] = preSessionToken; // eslint-disable-line no-param-reassign
  } else {
    config.headers['x-session-jwt'] = sessionJwt; // eslint-disable-line no-param-reassign
  }

  return config;
}); // Get sessionJwt from each response

axios_1.default.interceptors.response.use(function (response) {
  persistJwt(response);
  return response;
}, function (error) {
  persistJwt(error.response);
  return Promise.reject(error);
});
/**
 * Representacion de un request
 */

var Request = /*#__PURE__*/function () {
  function Request() {
    var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : API_BASE_URL;
    var path = arguments.length > 1 ? arguments[1] : undefined;
    var body = arguments.length > 2 ? arguments[2] : undefined;
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var method = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, Request);

    this.baseURL = baseURL;
    this.path = path;
    this.body = body;
    this.headers = headers;
    this.params = params;
    this.method = method;
  }

  _createClass(Request, [{
    key: "getPath",
    value: function getPath() {
      var queryUrl = querystring_1.default.stringify(this.params);
      return queryUrl ? "".concat(this.path, "?").concat(queryUrl) : this.path;
    }
  }, {
    key: "getBody",
    value: function getBody() {
      return this.body;
    }
  }, {
    key: "getHeaders",
    value: function getHeaders() {
      if (this.headers['Content-Type'] === null || this.headers['Content-Type'] === undefined) {
        this.headers['Content-Type'] = 'application/json';
      }

      if (this.headers.Accept === null || this.headers.Accept === undefined) {
        this.headers.Accept = 'application/json';
      }

      if (localStorage.token !== null && localStorage.token !== undefined) {
        this.headers.Authorization = "Bearer ".concat(localStorage.token);
      }

      return this.headers;
    }
  }, {
    key: "validate",
    value: function validate() {}
  }, {
    key: "hasBaseURL",
    value: function hasBaseURL() {
      return !this.isEmptyField(this.baseURL);
    }
  }, {
    key: "hasBody",
    value: function hasBody() {
      return !this.isEmptyField(this.body);
    }
  }, {
    key: "isEmptyField",
    value: function isEmptyField(field) {
      return field === null || field === undefined || field === '';
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        baseURL: this.baseURL,
        headers: this.getHeaders()
      };
    }
  }, {
    key: "call",
    value: function call() {
      var _this = this;

      return new this.method().call(this).then(function (response) {
        return _this.handleResponse(response);
      });
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(response) {
      // console.log(this.toString());
      // console.log("RESPONSE STATUS: " + response.status);
      // console.log("Resp.data : " + JSON.stringify(response.data));
      return response.data; // TODO Ver de usar un parser dinamicamente, para los casos que no son JSON.
    }
  }, {
    key: "toString",
    value: function toString() {
      return "REQUEST-METHOD : ".concat(this.method, " \n ") + "REQUEST-URL: : ".concat(this.baseURL).concat(this.getPath(), " \n ") + "REQUEST-BODY: \n ".concat(this.getBody(), " \n ") + "REQUEST-HEADERS: \n' ".concat(util_1.default.inspect(this.headers, {
        showHidden: false,
        depth: null
      }), " \n");
    }
  }]);

  return Request;
}();

exports.Request = Request;

var Method = /*#__PURE__*/function () {
  function Method() {
    _classCallCheck(this, Method);
  }

  _createClass(Method, [{
    key: "validateRequest",
    value: function validateRequest(request) {
      request.validate();
    }
  }, {
    key: "call",
    value: function call(request) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        try {
          _this2.validateRequest(request);

          resolve();
        } catch (error) {
          reject(error);
        }
      }).then(function () {
        return _this2.getRestCallback(request);
      });
    }
  }, {
    key: "getRestCallback",
    value: function getRestCallback() {}
  }, {
    key: "getName",
    value: function getName() {}
  }]);

  return Method;
}();

var Get = /*#__PURE__*/function (_Method) {
  _inherits(Get, _Method);

  var _super = _createSuper(Get);

  function Get() {
    _classCallCheck(this, Get);

    return _super.apply(this, arguments);
  }

  _createClass(Get, [{
    key: "validateRequest",
    value: function validateRequest(request) {
      _get(_getPrototypeOf(Get.prototype), "validateRequest", this).call(this, request);

      if (request.hasBody()) {
        throw new Error('No se puede hacer get con body');
      }
    }
  }, {
    key: "getRestCallback",
    value: function getRestCallback(request) {
      return axios_1.default.get(request.getPath(), request.getConfig());
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'GET';
    }
  }]);

  return Get;
}(Method);

exports.Get = Get;

var Delete = /*#__PURE__*/function (_Method2) {
  _inherits(Delete, _Method2);

  var _super2 = _createSuper(Delete);

  function Delete() {
    _classCallCheck(this, Delete);

    return _super2.apply(this, arguments);
  }

  _createClass(Delete, [{
    key: "validateRequest",
    value: function validateRequest(request) {
      _get(_getPrototypeOf(Delete.prototype), "validateRequest", this).call(this, request);

      if (request.hasBody()) {
        throw new Error('No se puede hacer delete con body');
      }
    }
  }, {
    key: "getRestCallback",
    value: function getRestCallback(request) {
      return axios_1.default.delete(request.getPath(), request.getConfig());
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'DELETE';
    }
  }]);

  return Delete;
}(Method);

exports.Delete = Delete;

var Post = /*#__PURE__*/function (_Method3) {
  _inherits(Post, _Method3);

  var _super3 = _createSuper(Post);

  function Post() {
    _classCallCheck(this, Post);

    return _super3.apply(this, arguments);
  }

  _createClass(Post, [{
    key: "getRestCallback",
    value: function getRestCallback(request) {
      return axios_1.default.post(request.getPath(), request.getBody(), request.getConfig());
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'POST';
    }
  }]);

  return Post;
}(Method);

exports.Post = Post;

var Put = /*#__PURE__*/function (_Method4) {
  _inherits(Put, _Method4);

  var _super4 = _createSuper(Put);

  function Put() {
    _classCallCheck(this, Put);

    return _super4.apply(this, arguments);
  }

  _createClass(Put, [{
    key: "getRestCallback",
    value: function getRestCallback(request) {
      return axios_1.default.put(request.getPath(), request.getBody(), request.getConfig());
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PUT';
    }
  }]);

  return Put;
}(Method);

exports.Put = Put;

var Patch = /*#__PURE__*/function (_Method5) {
  _inherits(Patch, _Method5);

  var _super5 = _createSuper(Patch);

  function Patch() {
    _classCallCheck(this, Patch);

    return _super5.apply(this, arguments);
  }

  _createClass(Patch, [{
    key: "getRestCallback",
    value: function getRestCallback(request) {
      return axios_1.default.patch(request.getPath(), request.getBody(), request.getConfig());
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'PATCH';
    }
  }]);

  return Patch;
}(Method);

exports.Patch = Patch;
/**
 * Funciones
 */

exports.init = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$baseURL = _ref.baseURL,
      baseURL = _ref$baseURL === void 0 ? API_BASE_URL : _ref$baseURL;

  axios_1.default.defaults.baseURL = baseURL;
};

exports.get = function (url) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$axios_1$defaul, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios_1.default.get(url, config);

          case 2:
            _yield$axios_1$defaul = _context.sent;
            data = _yield$axios_1$defaul.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.post = function (url, body) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$axios_1$defaul2, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios_1.default.post(url, body, config);

          case 2:
            _yield$axios_1$defaul2 = _context2.sent;
            data = _yield$axios_1$defaul2.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports.put = function (url, body) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _yield$axios_1$defaul3, data;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios_1.default.put(url, body, config);

          case 2:
            _yield$axios_1$defaul3 = _context3.sent;
            data = _yield$axios_1$defaul3.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

exports.del = function (url, body) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _yield$axios_1$defaul4, data;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return axios_1.default.delete(url, body, config);

          case 2:
            _yield$axios_1$defaul4 = _context4.sent;
            data = _yield$axios_1$defaul4.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};

exports.patch = function (url, body) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var _yield$axios_1$defaul5, data;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios_1.default.patch(url, body, config);

          case 2:
            _yield$axios_1$defaul5 = _context5.sent;
            data = _yield$axios_1$defaul5.data;
            return _context5.abrupt("return", data);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};